/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Monday, 9th Sept 2019
 *
 *  Company Profile View
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import TextFieldWithValidation from 'components/InputFields/TextFieldWithValidation';

// Material UI Components
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { useStores } from 'stores/RootStore';

const Profile = props => {
  const { classes } = props;
  const stores = useStores();
  const { hasChanges, handleNameChange, onSubmit, isAdmin } = stores.companyStore;
  const { name } = stores.companyStore.company;

  // Update AppStore Page View
  stores.appStore.setView('Profile');

  return (
    <Grid container direction='column'>
      <Grid item xs={12} md={8} lg={5}>
        <Grid container className={classes.gridContainer}>
          <Grid item sm={12} className={classes.addressGridItem}>
            <Grid container direction='column'>
              <form autoComplete='on' action='' onSubmit={onSubmit}>
                <Grid item xs={12}>
                  <TextFieldWithValidation
                    id='name'
                    name='Company Name'
                    type='text'
                    required
                    visible
                    disabled={!isAdmin}
                    message='Company name is a required field.'
                    value={name || ''}
                    handleInputChange={handleNameChange}
                    label='Company Name'
                    className={classes.defaultInputField}
                    fullWidth
                    margin='dense'
                    InputProps={{
                      className: classes.inputText,
                    }}
                    InputLabelProps={{
                      className: classes.inputLabelText,
                    }}
                  />
                </Grid>
                <Grid item>
                  {isAdmin ? (
                    <Button
                      disabled={!hasChanges}
                      variant='contained'
                      type='submit'
                      color='primary'
                      className={classes.saveButton}
                    >
                      Save
                    </Button>
                  ) : null}
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  gridContainer: {
    paddingBottom: '40px',
  },
  addressWrapper: {
    marginTop: '5px',
  },
  addressGridItem: {
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '5px',
    [theme.breakpoints.down('xs')]: {
      paddingRight: '15px',
      paddingLeft: '15px',
    },
  },
  avatarInput: {
    paddingTop: '50px',
  },
  avatarFooter: {
    fontSize: '10pt',
    textAlign: 'center',
  },
  sectionTitle: {
    marginTop: '15px',
    fontWeight: 600,
    color: theme.palette.primary.light,
  },
  sectionTitleLeft: {
    marginTop: '20px',
    marginLeft: '30px',
    fontWeight: 600,
  },
  sectionDivider: {
    width: '100%',
  },
  defaultInputField: {
    padding: '2px',
    [theme.breakpoints.down('xs')]: {
      padding: '2px',
    },
  },
  inputLabelText: {
    fontSize: '11pt',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10pt',
    },
  },
  saveButton: {
    marginTop: '25px',
  },
});

export default withStyles(styles, { withTheme: true })(observer(Profile));
